import enUS from '../locales/en-US.js';
import { o as observable } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CurrentLocale {
  constructor() {
    this.locale = enUS;
  }
}
__decorateClass([
  observable
], CurrentLocale.prototype, "locale");
const currentLocale = new CurrentLocale();
const setLocale = (locale) => {
  currentLocale.locale = locale;
};

class Localized {
  get locale() {
    return currentLocale.locale;
  }
}

export { Localized as L, setLocale as s };
